module.exports = {"title":"Stream","description":"Event Information","artists":"Artists","playbillder":"Event Program/Playbill"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/StreamNavigation/locales/fr.json
// module id = 820
// module chunks = 0